import { Navigate, Outlet } from 'react-router-dom';
import { Box, Container, Flex } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { useRootStore } from 'core/hooks/use-root-store';
import { ReactNode } from 'react';
import NavBar from 'Components/element/NavBar';
import Footer from 'Components/element/Footer';
import { GlobalLoader } from 'shared/components/global-loader';
import { CandidateSidebar } from 'candidate/candidate-sidebar';
const containerSize = "1550px"

const CandidateRoutesGuardView = () => {
   const rootStore = useRootStore();

   function render(): ReactNode {
      if (rootStore.userStore.isInit) {
         return (
            <Box width="100%" height="100vh">
               <GlobalLoader loaderStore={rootStore.globalLoader} />
            </Box>
         );
      }

      if (!rootStore.userStore.user) {
         return <Navigate to="/" replace />;
      }

      if (rootStore.userStore.user && rootStore.userStore.user.user_type !== 'candidate') {
         return <Navigate to="/auth/candidate-login" replace />;
      }

      return <Outlet />;
   }

   return (
      <>
         <NavBar />
         <Container my="8" pl="5" maxWidth={containerSize}>
            <Flex
               direction={{
                  md: 'row',
                  "initial": "column"
               }}
               gap="6"
            >
               <Box minWidth="300px">
                  <CandidateSidebar />
               </Box>

               {render()}
            </Flex>
         </Container>

         <Footer />
      </>
   );
};

export const CandidateRoutesGuard = observer(CandidateRoutesGuardView);
